/*
 * @Author: wwlsky
 * @Date: 2025-05-19 15:53:58
 * @LastEditTime: 2025-05-20 11:29:42
 */
/**
 * Main application entry point
 */
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import axios from 'axios';
import App from './App.vue';
import router from './router';

// 设置全局axios基础URL
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:4901/api';

// 处理外部扫码
const handleExternalUrl = () => {
  const currentUrl = window.location.href;
  if (currentUrl.includes('unlock.html')) {
    const searchParams = new URLSearchParams(window.location.search);
    const data = searchParams.get('data');
    if (data) {
      // 确保应用内的解密页面正确获取参数
      console.log('解析二维码参数:', data);
    }
  }
};

/**
 * Create and configure the Vue application
 */
const app = createApp(App);

// Use plugins
app.use(createPinia());
app.use(router);
app.use(ElementPlus);

// Mount the app
app.mount('#app');

// 启动应用时处理外部URL
handleExternalUrl();
